import React from "react";
import Container from "react-bootstrap/Container";

//component
import Link from "next/link";
import dynamic from "next/dynamic";
import {useTranslation} from "next-i18next";
import {capitalize} from "../../helper/utilityHelper";

// style
import styles from "./Sitemap.module.scss";

const FullviewLink = dynamic(() => import('../icons/fullviewlink'))

const Sitemap = (props) => {
  const { t } = useTranslation("common");
  const { currLocale, catList, newsList, newsTags, BlogCategoryData, EventData, BlogData } = props;

  const nft_blockchains = [
    { value: 1, url: "/nft/explore/ethereum", label: t("common:ethereum_nft") },
    { value: 2, url: "/nft/explore/polygon", label: t("common:polygon_nft") },
    { value: 3, url: "/nft/explore/tezos", label: t("common:tezos_nft") },
    { value: 4, url: "/nft/explore/flow", label: t("common:flow_nft") },
  ];

  const tranding = [
    { value: 1, url: "/nft/collections", label: t("common:verified_nft_collections"),},
    { value: 2, url: "/nft/tokens", label: t("common:top_tokens") },
    { value: 3, url: "/nft/profiles", label: t("common:top_profiles") },
    { value: 4, url: "/nft/calendar", label: t("common:NFT_calendar") },
    { value: 5, url: "/nft/live-auction", label: t("common:nft_auction") },
  ];

  const other = [
    { value: 1, url: "/nft/about", label: t("common:about") },
    { value: 2, url: "/nft/contact", label: t("common:contact_us") },
    { value: 3, url: "https://help.upyo.com/en/ ", label: t("common:help_link") },
    { value: 4, url: "/nft/app", label: t("common:nft_app") },
  ];

  return (
    <>
      <div className={styles.sitemap}>
        <Container>
          <div className={`${styles.topHeader}`}>
            <h1 className="h3"> {t("common:upyo_sitemap")}</h1>
            <p>{t("common:sitemap_desc")}</p>
          </div>
          <div className={styles.sitemapGrid}>
            <h2>
              {t("common:nft_categories")}
              <Link href="/nft/category"
                    rel="noopener" target="_blank">
                  <FullviewLink />
              </Link>
            </h2>

            {/* NFT Categoery List */}
            <ul className="d-flex flex-wrap">
              { catList?.map((item) => (
                  <li key={item.category_name}>
                    <Link
                      locale={currLocale}
                      href={"/nft/category/" + item.category_name.split(" ").join("-" )}>
                        {" "}
                        {currLocale == "en"
                          ? capitalize(item.category_name)
                          : item.category_name_arabic}
                    </Link>
                  </li>
                ))}
            </ul>

            {/* NFT Blockchain list */}
            <h2>
              {t("common:nft_blockchains")}
              <Link href="/nft/explore" rel="noopener" target="_blank">
                  <FullviewLink />
              </Link>
            </h2>
            <ul className="d-flex flex-wrap">
              { nft_blockchains?.map((item) => (
                  <li key={item.url}>
                    <Link locale={currLocale} href={item.url}>
                      {item.label}
                    </Link>
                  </li>
                ))}
            </ul>

            {/* NFT Tranding List */}
            <h2> {t("common:trending")}</h2>
            <ul className="d-flex flex-wrap">
              { tranding?.map((item) => (
                  <li key={item.url}>
                    <Link locale={currLocale} href={item.url}>
                      {item.label}
                    </Link>
                  </li>
                ))}
            </ul>
            <h2> {t("common:tools")}</h2>
            <ul className="d-flex flex-wrap">
              <li>
                <Link href="/nft/tools/ens-domains">
                  {t("common:ENS_domain")}
                </Link>
              </li>
            </ul>
            <h2>
              {t("common:blog")}
              <Link href="/blog" rel="noopener" target="_blank">
                  <FullviewLink />
              </Link>
            </h2>
            <ul className="d-flex flex-wrap">
            { BlogData?.map((item) => (
                  <li key={item.slug}>
                    <Link locale={currLocale} href={"/post/" + item.slug}>
                      {item.title}
                    </Link>
                  </li>
                ))}
            </ul>
             
            <h2> {t("common:blog_categories")}</h2>
            <ul className="d-flex flex-wrap">
            { BlogCategoryData?.map((item) => (
                  <li key={item.slug}>
                    <Link locale={currLocale} href={"/blog/" + item.slug}>
                      {item?.mainContentOfCategory?.titleH1}
                    </Link>
                  </li>
                ))}
            </ul>

            {/* Recent News Section List */}
            <h2>
              {t("common:recent_news")}
              <Link href="/news" rel="noopener" target="_blank">
                  <FullviewLink />
              </Link>
            </h2>
            <ul className="d-flex flex-wrap">
              { newsList.news?.map((item) => (
                  <li key={item.slug}>
                    <Link
                      locale={currLocale}
                      href={"/article/" + item.slug}>
                        {" "}
                        {item.title}
                    </Link>
                  </li>
                ))}
            </ul>

            {/* News Categoery List  */}
            <h2> {t("common:news_categories")}</h2>
            <ul className="d-flex flex-wrap">
              {newsList.categories &&
                newsList.categories.slice(1,15).map((item) => (
                  <li key={item.slug}>
                    <Link
                      locale={currLocale}
                      href={"/news/" + item.slug}>
                      {item.name +" " +t("common:news") }
                    </Link>
                  </li>
                ))}
            </ul>
            <h2> {t("common:top_news_tags")}</h2>
            <ul className="d-flex flex-wrap">
              { newsTags.newsTopTags?.map((item) => (
                  <li key={item.slug}>
                    <Link
                      locale={currLocale}
                      href={"/news/tags/" + item.slug}>
                      {item?.mainContentOfCategory?.titleH1}
                    </Link>
                  </li>
                ))}
            </ul>

            {/* Events Section List */}
            <h2>
              {t("common:events_nav")}
              <Link href="/events"
                    rel="noopener" target="_blank">
                  <FullviewLink />
              </Link>
            </h2>
        
            <ul className="d-flex flex-wrap">
            { EventData?.map((item) => (
                  <li key={item.slug}>
                    <Link
                      locale={currLocale}
                      href={"/events/category/" + item.slug}>
                      {item?.mainContentOfCategory?.titleH1}
                    </Link>
                  </li>
                ))}
            </ul>

            {/* Other Link List */}
            <h2> {t("common:other_links")}</h2>
            <ul className="d-flex flex-wrap">
              { other?.map((item) => (
                  <li key={item.url}>
                    <Link locale={currLocale} href={item.url}>
                      {item.label}
                    </Link>
                  </li>
                ))}
            </ul>
          </div>
        </Container>
      </div>
    </>
  );
};

export default Sitemap;
